module.exports = __webpack_public_path__ + "img/imagem-da-home-800.73fe7406.png";